import { render, staticRenderFns } from "./communityservice.vue?vue&type=template&id=aecf93fe&"
import script from "./communityservice.vue?vue&type=script&lang=js&"
export * from "./communityservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports